import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ComponentType } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { IconArrowLeft } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { getCdnUrl } from '@/utils/url';
import './pink-box.css';
import { converSecondsToTime } from '../../_utils/convert-seconds-to-time';
interface Props {
  deactivationCountdownSecs?: number;
  href: string;
  id?: string;
  componentId?: string;
  elementName?: string;
}
const PinkBox = ({
  deactivationCountdownSecs = 0,
  href,
  id,
  componentId,
  elementName
}: Props) => {
  const [seconds, setSeconds] = useState(deactivationCountdownSecs);
  const {
    isMobile
  } = useMobileDetect();
  useEffect(() => {
    if (seconds <= 0) return;
    const intervalId = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [seconds]);
  const {
    hours,
    minutes,
    remainingSeconds
  } = converSecondsToTime(seconds);
  const handleClick = (type: 'show-more-link' | 'banner-link') => {
    sendCtaClickEvent({
      elementType: ComponentType.ProductList,
      elementIndex: type === 'banner-link' ? 1 : 0,
      itemID: id ?? '',
      elementName,
      destinationUrl: href ?? '',
      componentId: componentId ?? '',
      ImageUrl: null
    });
    Webengage.trackCtaAction({
      component_id: componentId ?? '',
      banner_type: ComponentType.ProductList,
      banner_name: elementName ?? '',
      banner_index: type === 'banner-link' ? 1 : 0,
      url_destination: href || '',
      item_id: id || '',
      image_url: ''
    });
  };
  return <AppNextLink prefetch={false} href={href} className={classNames('flex min-h-full min-w-[120px] items-center justify-between gap-3 lg:min-w-[180px]', isMobile ? 'flex-row pr-2 pt-2' : 'flex-col px-7.5 py-1.5')} data-sentry-element="AppNextLink" data-sentry-component="PinkBox" data-sentry-source-file="pink-box.tsx">
            <div onClick={() => handleClick('banner-link')} className={classNames('flex items-center gap-3 lg:flex-col', !isMobile && 'flex-1 justify-between')}>
                <div role='img' aria-label='جعبه صورتی' className='min-h-[34px] w-[120px] bg-contain bg-center bg-no-repeat lg:min-h-[40px] lg:w-[140px]' style={{
        backgroundImage: `url(${getCdnUrl('/_toad/images/pink-box/pink-box-header.webp')})`
      }} />
                {!isMobile && <div role='img' aria-label='بزرگ‌ترین حراج روزانه' className='h-25 w-25 max-w-none animate-pink-box bg-contain bg-center bg-no-repeat lg:h-34 lg:w-34' style={{
        backgroundImage: `url(${getCdnUrl('/_toad/images/pink-box/pink-box-image.webp')})`
      }} />}

                {!isMobile && <span className='text-caption-12 font-bold text-text-white lg:text-body-14'>
                        {/* This text is used in SSR check tool, Don't change it without checking the tool first */}
                        بزرگ‌ترین حراج روزانه
                    </span>}

                {!!deactivationCountdownSecs && <div className='flex items-center gap-0.5'>
                        <span className='number-block'>{remainingSeconds}</span>
                        <span className='number-seperator'>:</span>
                        <span className='number-block'>{minutes}</span>
                        <span className='number-seperator'>:</span>
                        <span className='number-block'>{hours}</span>
                    </div>}
            </div>

            {isMobile && <div onClick={() => handleClick('show-more-link')} className='flex min-w-fit max-w-fit flex-1 items-center justify-end gap-2 text-text-white'>
                    <Button graphicStyle='text' size='small' className='px-0 py-1.5 text-text-white hover:text-text-white'>
                        {/* This text is used in SSR check tool, Don't change it without checking the tool first */}
                        مشاهده همه
                    </Button>
                    <IconArrowLeft className='h-3 w-3' />
                </div>}
        </AppNextLink>;
};
export default PinkBox;